import React from 'react';
import SiteFooter from './SiteFooter';
import { puckImageField as imageField } from '../../../puck/fields/puckImageField';
import { puckColorField } from '../../../puck/fields/createPuckColorField';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';
import SiteFooterLinkStyleField from './SiteFooterLinkStyleField';
import SiteFooterLinksField from './SiteFooterLinksField';
import { puckAdvancedSectionField, puckSectionField } from '../../../puck/fields/puckSectionField';

const siteFooterConfig = {
  label: 'Pied de page',
  defaultProps: {
    // Multi-colonnes (par défaut) — les 2 autres sont plus sobres.
    variant: 'columns',
    // Nom de la société : texte riche (édité inline sur le canvas, toolbar au survol).
    companyName: 'Nom de la société',
    logoUrl: '',
    links: [],
    // Style commun des liens (toolbar : police, taille, B/I/U, couleur) +
    // nombre de colonnes, éditées dans le même champ custom (linkStyle).
    linkStyle: {
      fontFamily: '', fontSize: '0.875rem', bold: false, italic: false, underline: false, color: '',
    },
    columns: 2,
    // Ligne de copyright : texte riche libre (édité inline sur le canvas),
    // décorrélé du nom de la société ci-dessus — l'année et le nom y sont en
    // dur, modifiables directement dans le texte comme n'importe quel autre.
    copyrightText: '© 2026 Nom de la société — Mention légale',
    backgroundColor: '#1a1a1a',
    paddingX: '1rem', // = 16px, la marge horizontale réellement rendue par défaut
  },
  fields: {
    _section1: puckSectionField('Contenu'),
    logoUrl: imageField('Logo'),
    links: {
      type: 'custom',
      label: 'Liens',
      render: (props) => <SiteFooterLinksField {...props} />,
    },
    linkStyle: {
      type: 'custom',
      label: 'Style des liens',
      render: (props) => <SiteFooterLinkStyleField {...props} />,
    },

    _section2: puckSectionField('Style'),
    variant: {
      type: 'select',
      label: 'Style de footer',
      /* Options trop longues pour la demi-largeur. */
      layout: 'stacked',
      options: [
        { label: 'Multi-colonnes (par défaut)', value: 'columns' },
        { label: 'Centré (sobre et épuré)', value: 'centered' },
        { label: 'Minimal (barre fine)', value: 'minimal' },
      ],
    },
    backgroundColor: puckColorField('Couleur de fond', { allowTransparent: true }),

    _section3: puckAdvancedSectionField(),
    paddingX: puckPxSpacingField('Marge horizontale du footer'),
  },
  render: (props) => <SiteFooter {...props} />,
};

export default siteFooterConfig;
